'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('reciboRetencaoIss', {
                parent: 'out',
                url: '/recibo-retencao-iss',
                ncyBreadcrumb: {
                    label: 'Recibo de Retenção de Iss'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/externo/reciboRetencaoIss/reciboRetencaoIss.html',
                        controller: 'ReciboRetencaoIssController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('situacaoParcela');
                        return $translate.refresh();
                    }]
                }
            })
    });
